import React, { useEffect, useState, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './style.scss';
import {
  Table, Select, Button,
} from 'antd';
import { v4 as uuidv4 } from 'uuid';
import Helpers from '@Apis/helpers';
import TenantActions from '@Actions/tenantActions';
import TallyIntegrationActions from '@Actions/integrations/tallyIntegrationActions';
import TaxActions from '@Actions/taxActions';
import PRZSelect from '../../../../../../Common/UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
const TallyMapSalesTaxes = ({
  user, tenants, getTallyConnections, tallyConnections, connectTenantToTallyLocation,
  connectTenantToTallyLocationLoading, setStep, getTallyConnectionsLoading,
  stepNumber, getTaxes, taxes,
}) => {
  const [taxesData, setTaxesData] = useState(
    // [{
    //   tax_name: 'CGST0',
    //   tax_type: 'GST',
    //   tax_group: 'GST0',
    //   tax_percentage: 0,

    // }, {
    //   tax_name: 'SGST0',
    //   tax_type: 'GST',
    //   tax_group: 'GST0',
    //   tax_percentage: 0,

    // }, {
    //   tax_name: 'CGST2.5',
    //   tax_type: 'GST',
    //   tax_group: 'GST5',
    //   tax_percentage: 2.5,

    // }, {
    //   tax_name: 'SGST2.5',
    //   tax_type: 'GST',
    //   tax_group: 'GST5',
    //   tax_percentage: 2.5,

    // }, {
    //   tax_name: 'CGST6',
    //   tax_type: 'GST',
    //   tax_group: 'GST12',
    //   tax_percentage: 6,

    // }, {
    //   tax_name: 'SGST6',
    //   tax_type: 'GST',
    //   tax_group: 'GST12',
    //   tax_percentage: 6,

    // }, {
    //   tax_name: 'CGST9',
    //   tax_type: 'GST',
    //   tax_group: 'GST18',
    //   tax_percentage: 9,

    // }, {
    //   tax_name: 'SGST9',
    //   tax_type: 'GST',
    //   tax_group: 'GST18',
    //   tax_percentage: 9,

    // }, {
    //   tax_name: 'CGST14',
    //   tax_type: 'GST',
    //   tax_group: 'GST28',
    //   tax_percentage: 14,

    // }, {
    //   tax_name: 'SGST14',
    //   tax_type: 'GST',
    //   tax_group: 'GST28',
    //   tax_percentage: 14,

    // }, {
    //   tax_name: 'IGST0',
    //   tax_type: 'GST',
    //   tax_group: 'IGST0',
    //   tax_percentage: 0,

    // }, {
    //   tax_name: 'IGST5',
    //   tax_type: 'GST',
    //   tax_group: 'IGST5',
    //   tax_percentage: 5,

    // }, {
    //   tax_name: 'IGST12',
    //   tax_type: 'GST',
    //   tax_group: 'IGST12',
    //   tax_percentage: 12,

    // }, {
    //   tax_name: 'IGST18',
    //   tax_type: 'GST',
    //   tax_group: 'IGST18',
    //   tax_percentage: 18,

    // }, {
    //   tax_name: 'IGST28',
    //   tax_type: 'GST',
    //   tax_group: 'IGST28',
    //   tax_percentage: 28,

    // }],
  );
  const [taxOptions, setTaxesOptions] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState('');
  const integrationTallyIdURL = Number(Helpers.getValueFromUrl('it_id'));

  useEffect(() => {
    getTallyConnections(user?.tenant_info?.org_id);
    getTaxes(user?.tenant_info?.org_id, 0, 100, null, false);
  }, []);

  const tallyConnectionsFilteredData = tallyConnections?.filter((connection) => connection?.it_id === integrationTallyIdURL);

  useEffect(() => {

    let copyTaxes = [];
    if (taxes?.success) {

      copyTaxes = taxes?.data?.filter((item) => (item?.parent_tax_type === 'GST'))?.map((item) => ({
        tax_name: item?.tax_name,
        tax_type: item?.parent_tax_type,
        tax_group: item?.parent_tax?.find((i) => i?.tax_type_name === 'GST')?.tax_name,
        tax_percentage: item?.tax_value,
      }));
    }

    setTaxesOptions(tallyConnectionsFilteredData[0]?.taxes?.map((item) => ({ ...item, key: uuidv4() })) || []);

    if (tallyConnectionsFilteredData[0]?.sales_taxes_mapping?.length) {

      setTaxesData(copyTaxes?.map((item) => {
        const matchedItem = tallyConnectionsFilteredData?.[0]?.sales_taxes_mapping?.find(i => i?.tax_name === item?.tax_name);
        return {
          ...item,
          key: uuidv4(),
          tally_ledger_name: matchedItem?.tally_ledger_name,
        }
      }))
    } else {
      setTaxesData(copyTaxes?.map((item) => ({ ...item, key: uuidv4(), })));
    }
  }, [tenants, tallyConnections, taxes]);

  const updateTableValue = (key, value, label) => {
    const data = taxesData.map((tenant) => {
      if (tenant.key === key) {
        // eslint-disable-next-line no-param-reassign
        tenant[label] = value;
        return tenant;
      }
      return tenant;
    });
    setTaxesData(data);
  };

  const getDataSource = (data) => (data ? JSON.parse(JSON.stringify(data?.filter((tenant) => !tenant.is_deleted))) : []);

  const columns = [
    {
      title: 'Procuzy Taxes',
      width: '312px',
      render: (record) => (
        <div>

          {record?.tax_name}
        </div>
      ),
    },
    {
      title: 'Tally Taxes',
      render: (record) => (
        <div className="select__tally__tax">
          <PRZSelect
            onChange={(value) => {
              updateTableValue(record?.key, value, 'tally_ledger_name');
            }}
            showSearch
            allowClear
            filterOption={(input, option) =>
              option?.children.toLowerCase().includes(input.toLowerCase())
            }
            value={record.tally_ledger_name}
            hideTitle
            disabled={connectTenantToTallyLocationLoading}
            placeholder=""
          >
            {taxOptions?.map((tax) => (
              <Option value={tax?.tax_name} key={tax?.key}>
                {tax?.tax_name}
              </Option>
            ))}
          </PRZSelect>
        </div>
      ),
    },
  ];

  const isDataValid = (data) => {
    for (let i = 0; i < data?.length; i++) {
      if (!data[i]?.tally_ledger_name) {
        return false;
      }
    }
    return true;
  };

  const handleSubmit = () => {
    setFormSubmitted(true);
    // if (isDataValid(taxesData)) {
    const payload = {
      ...tallyConnectionsFilteredData[0],
      sales_taxes_mapping: taxesData,
    };

    connectTenantToTallyLocation(payload, () => {
      setStep(stepNumber + 1);
    });
    // } else {
    //   notification.error({
    //     message: 'Please select taxes for every tally taxes',
    //     placement: 'top',
    //     duration: 4,
    //   });
    // }
  };

  return (
    <Fragment>
      {(getTallyConnectionsLoading)
        ? (
          <div className="tally-integration__loader__wrapper">

            {[...Array(5).keys()].map((item) => (
              <div key={item} className="tally-integration__loader-row">
                <div className="loadingBlock  tally-integration__loader__line1" />
                <div className="loadingBlock  tally-integration__loader__line2" />
                <div className="loadingBlock  tally-integration__loader__line3" />
              </div>
            ))}
            <div className="loadingBlock tally-integration__loader__line-btn1" />
            <div className="loadingBlock tally-integration__loader__line-btn2" />
          </div>
        )
        : (
          <div>
            <div className="integration-step__wrapper">
              <div className="ant-row">
                <div className="ant-col-md-18">
                  <Table
                    title={() => "Map sales taxes of Procuzy with Tally"}
                    columns={columns}
                    loading={getTallyConnectionsLoading || connectTenantToTallyLocationLoading}
                    dataSource={getDataSource(taxesData) || []}
                    size="small"
                    pagination={false}
                  />
                </div>
              </div>
            </div>
            <div className="integration-step__footer" style={{ display: 'flex', paddingTop: '10px', paddingLeft: '15px' }}>
              <Button
                onClick={() => setStep(6)}
                type="primary"
                disabled={connectTenantToTallyLocationLoading}
                ghost
              >
                Back
              </Button>
              &nbsp;&nbsp;
              <Button
                onClick={() => handleSubmit()}
                type="primary"
                disabled={connectTenantToTallyLocationLoading}
              >
                Save and Continue
              </Button>
            </div>
          </div>
        )}
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, TenantReducers, TallyIntegrationReducers, TaxReducers, }) => ({
  user: UserReducers.user,
  tenants: TenantReducers.tenants,
  tallyConnections: TallyIntegrationReducers.tallyConnections,
  connectTenantToTallyLocationLoading: TallyIntegrationReducers.connectTenantToTallyLocationLoading,
  pullTallyProductsLoading: TallyIntegrationReducers.pullTallyProductsLoading,
  pullTallyVendorsLoading: TallyIntegrationReducers.pullTallyVendorsLoading,
  taxes: TaxReducers.taxes,
});
const mapDispatchToProps = (dispatch) => ({
  getTenants: (page, keyword, isVerified, orgId) => dispatch(
    TenantActions.getTenants(page, keyword, isVerified, orgId),
  ),
  getTallyConnections: (orgId, callback) => dispatch(TallyIntegrationActions.getTallyConnections(orgId, callback)),
  connectTenantToTallyLocation: (payload, callback) => dispatch(TallyIntegrationActions.connectTenantToTallyLocation(payload, callback)),
  getTaxes: (orgId, page, limit, isActive, isTaxGroup) => dispatch(TaxActions.getTaxes(orgId, page, limit, isActive, isTaxGroup)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TallyMapSalesTaxes));
